var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"faq"},[_c('section',{staticClass:"faq_detail"},[_c('div',{staticClass:"faq_page"},[_c(_vm.target,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }